import React, { useReducer, useEffect, useCallback } from "react";
import AnimatedPageContainer from "../../../assets/containers/AnimatedPageContainer";
import Classes from "../styles/style.module.css";
import SubmitReserveModal from "./SubmitReserveModal";
import appApi from "../../../assets/utils/AppApi";
import errorHandler from "../../../assets/utils/ErrorHandler";
import { useParams } from "react-router";
import Loading from "../../../assets/containers/loadingDialog";
import EventSecitonElement from "./EventSecitonElement";
import NoResultAlter from "../../../assets/components/UI/NoResultAlter";
import SubmitCountModal from "./SubmitCountModal";

const initialState = {
  showSubmitModal: false,
  showCountModal: false,
  participants: 0,
  loading: false,
  sections: [],
  selected: null,
};

function reducer(state, action) {
  switch (action.type) {
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "SET_SECTIONS":
      return { ...state, sections: action.payload };
    case "SHOW_COUNT_MODAL":
      return { ...state, showCountModal: true, selected: action.payload };
    case "HIDE_COUNT_MODAL":
      return { ...state, showCountModal: false };
    case "SHOW_SUBMIT_MODAL":
      return { ...state, showSubmitModal: true, participants: action.payload };
    case "HIDE_SUBMIT_MODAL":
      return { ...state, showSubmitModal: false };
    default:
      return state;
  }
}

const EventSections = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const params = useParams();

  const getAllSections = useCallback(async () => {
    dispatch({ type: "SET_LOADING", payload: true });
    try {
      const response = await appApi.get(`/event/getsingle/${params.eventId}`);
      const { data } = response;
      dispatch({ type: "SET_SECTIONS", payload: data.sections });
    } catch (error) {
      errorHandler(error);
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  }, [params.eventId]);

  useEffect(() => {
    getAllSections();
  }, [getAllSections]);

  return (
    <AnimatedPageContainer>
      <div className={Classes.container}>
        {state.loading ? (
          <div className="w-100 d-flex justify-content-center py-5 my-5">
            <Loading size={30} />
          </div>
        ) : state.sections.length !== 0 ? (
          state.sections.map((event) => (
            <EventSecitonElement
              key={event._id}
              event={event}
              handleClick={() => {
                dispatch({ type: "SHOW_COUNT_MODAL", payload: event });
              }}
            />
          ))
        ) : (
          <NoResultAlter className={"w-100  py-5 my-5"} />
        )}
      </div>
      <SubmitCountModal
        show={state.showCountModal}
        data={state.selected}
        closeHandler={() => dispatch({ type: "HIDE_COUNT_MODAL" })}
        handleConfirm={(count) => {
          dispatch({ type: "SHOW_SUBMIT_MODAL", payload: count });
          dispatch({ type: "HIDE_COUNT_MODAL" });
        }}
      />
      <SubmitReserveModal
        participant={state.participants}
        data={state.selected}
        show={state.showSubmitModal}
        closeHandler={() => dispatch({ type: "HIDE_SUBMIT_MODAL" })}
      />
    </AnimatedPageContainer>
  );
};

export default EventSections;
